import type { ClDetailsDataProps } from '@pages/Users/context/types'
import type { UserDetailsModalFormProps } from './types'

export const setInitialValues = (data: ClDetailsDataProps | null) => {
  if (!data) return null

  const formData: UserDetailsModalFormProps = {
    id: data.id || '',
    profitCenterCode: data.profitCenterCode || '',
    businessUnit: data.buDescription || '',
    segment: data.segmentDescription || '',
    directorate: data.boardOfDirectorsDescription || '',
    profitCenter: data.profitCenterCode || '',
    profitCenterName: data.profitCenterName || '',
    profitCenterType: data.profitCenterType || '',
    cep: data.cep || '',
    address: data.address || '',
    number: data.number || '',
    neighborhood: data.neighborhood || '',
    city: data.city || '',
    uf: data.uf || '',
    email: data.email || '',
    regional: data.regional || '',
    managerAreaName: data.areaManagerName || '',
    managerAreaEmail: data.areaManagerEmail || ''
  }

  return formData
}
